import { combineReducers } from "redux"
import { dispatch } from "."

/**
 * 初始化模块
 * @param {object} models
 * @returns
 */
function initModels(models) {
  const reducers = {};
  Object.keys(models).forEach(key => {
    const model = models[key];
    // 包装 model.actions 方法
    const actions = model.actions;
    if (actions) {
      Object.keys(actions).forEach(actionKey => {
        const method = actions[actionKey];
        actions[actionKey] = function () {
          return method.apply(actions, [{ dispatch }, ...arguments]);
        };
      });
    };
    // 将 models 转换为 reducers 处理动作分发
    reducers[key] = (prevState, action) => {
      return handleAction(model, prevState, action);
    };
  });
  return reducers;
}

/**
 * 处理行动
 * @param {object} model
 * @param {object} prevState
 * @param {object} action
 * @returns
 */
function handleAction(model, prevState, action) {
  const { type, payload } = action;
  if (0 === type.indexOf("@@redux")) {
    // 处理 Redux 默认 Action
    const method = type;
    if (model.reducers && model.reducers[method]) {
      return model.state = model.reducers[method](prevState, payload);
    }
    return model.state;
  }
  // 调用 Model 状态更新方法
  const method = type.split("/")[1];
  if (model.reducers && model.reducers[method]) {
    return model.state = model.reducers[method](prevState, payload);
  }
  return prevState;
}

export function combineModels(models) {
  return combineReducers(initModels(models));
};
